import React from 'react'

import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { ApplicationState } from '@store/types'

import routes from './routes'

const RequireAuth: React.FC = () => {
  const { accessToken } = useSelector((state: ApplicationState) => state.session)
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  if (!isApp && !accessToken) return <Navigate to={routes.VERIFICACAO} replace />

  return <Outlet />
}

export default RequireAuth
